export default __webpack_public_path__ + "f776757a0b22c8ac85d03afa92cbea03.png";